
import classNames from 'classnames';
import { Container } from 'reactstrap';
import NavBar from './Navbar2';
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import {FirebaseDB} from "../../FirebaseDB"
import Mapbox from "./WorldWideCCTV"
//import MapView from "./MapViewCom"
// import { Link, useNavigate } from "react-router-dom";
// import { auth, logInWithEmailAndPassword,logout, signInWithGoogle } from "./firebase";



class LeafletCom extends React.Component {

  

  constructor(props) {
    super(props);

    this.state = {
//        login : Login
    }

    this.previousWidth = -1;
  }

  render() {
    return (
      <Container fluid className={classNames('content', { 'is-open': this.props.isOpen })}>
          <Mapbox></Mapbox>


        
      </Container>

      
    );
  }
}




export default LeafletCom;
